interface IWorkerOne {
  hello?: (name: string) => Promise<string>;
  postMessage?: (data: any) => void;
  onmessage?: (data: any) => void | null;
}

let workerInstance = null;

export const startWorker = () => {
  if (!workerInstance) {
    console.log("INSTANCE STARTING startWorker");
    workerInstance = new Worker(new URL("./gx.worker.ts", import.meta.url));
  }
  return workerInstance;
};

export const terminateWorker = () => {
  if (workerInstance) {
    console.log("INSTANCE TERMINATING terminateWorker");
    workerInstance.terminate();
    workerInstance = null;
  }
};

export const getWorker = () => {
  return workerInstance;
};
